import { Pagination, paginationToParams } from '../Pagination';
import { SortingOrder } from '../SortingOrder';

export type UserOrderField =
  | 'id'
  | 'name'
  | 'email'
  | 'point'
  | 'createdAt'
  | 'updatedAt';

export interface UserFilter {
  id?: string;
  email?: string;
  phone?: string;
  name?: string;
  orderBy: UserOrderField;
  order: SortingOrder;
  pagination: Pagination;
}

export const getDefaultUserFilters = (): UserFilter => ({
  orderBy: 'name',
  order: 'asc',
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const userFilterToParams = (userFilter: UserFilter) => ({
  id: userFilter.id ? Number(userFilter.id) : undefined,
  email: userFilter.email || undefined,
  phone: userFilter.phone || undefined,
  name: userFilter.name || undefined,
  'order-by': userFilter.orderBy,
  desc: userFilter.order === 'desc',
  ...paginationToParams(userFilter.pagination),
});
